<template>
  <div class="slide" @mouseover="stop" @mouseout="move">
      <div class="slideshow">
          <transition-group tag="ul" name="image">
             <li v-for="(img,index) in imgs" :key="index" v-show='index === mark' @click="imgClicked">
                  <a href="javascript:void(0)">
                      <img :src="img.decorateContent+'@160h_1020w_2e_90Q'"/>
                  </a>
              </li>
          </transition-group>
      </div>
      <div class="bar">
          <span v-for="(item,index) in imgs" :key="index" @click="change(index)" :class="{'active':index===mark}"></span>
      </div>
  </div>
</template>
<script>
export default {
    props: {
        index: {
            type: Number,
            default: 0
        },
        intervalMS: {
            type: Number,
            default: 3000
        },
        imgs: {
            type: Array,
            validator: function (val) {
                if (val && Array.isArray(val)) {
                    return val.find(item => {
                        return !item.decorateContent || !item.decorateContent.length;
                    })
                        ? false
                        : true;
                }
            }
        }
    },
    data: function () {
        return {
            mark: this.index
        };
    },
    created: function () { },
    methods: {
        autoPlay() {
            this.mark++;
            if (this.mark === this.imgs.length) {
                this.mark = 0;
            }
        },
        play() {
            this.timerId = setInterval(this.autoPlay, this.intervalMS);
        },
        change(i) {
            this.mark = i;
        },
        move() {
            this.play();
        },
        stop() {
            clearInterval(this.timerId);
        },
        imgClicked() {
            let imgItem = this.imgs[this.mark];
            this.$emit("imgClick", imgItem);
        }
    },
    created: function () {
        this.play();
    }
};
</script>
<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
.slide {
  overflow: hidden;
  position: relative;
  height: 160px;
  .slideshow {
    ul {
      margin: 0;
      list-style-type: none;
      padding-left: 0;
      white-space: nowrap;
      li {
        width: 100%;
        height: 100%;
        position: absolute;
      }
    }
    a {
      &:focus {
        outline: none;
      }
      img {
        width: 100%;
        height: 160px;
      }
    }
  }
  .bar {
    position: absolute;
    width: 100%;
    bottom: 10px;
    margin: 0 auto;
    z-index: 10;
    text-align: center;
    span {
      width: 40px;
      height: 5px;
      background-color: white;
      display: inline-block;
      margin-right: 10px;
      &.active {
        background-color: #158dfb !important;
      }
    }
  }
  .image-enter-active {
    transform: translateX(0);
    transition: all 1.2s ease;
  }
  .image-leave-active {
    transform: translateX(-100%);
    transition: all 1.2s ease;
  }
  .image-enter {
    transform: translateX(100%);
  }
  .image-leave {
    transform: translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// SlideShow.vue?0f2cfbb2